import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { AppBar, Toolbar, Typography, Breadcrumbs, Box } from '@mui/material';

import { ConsentBanner } from '@/features/ConsentBanner';
import { FEATURES_FLAG_KEYS } from '@/features/featuresFlag/apis/featureFlag.keys';
import { useFeaturesFlagState } from '@/features/featuresFlag/hooks';
import { LanguageSwitcher } from '@/features/languageSwitcher/LanguageSwitcher';
import { useFolderNumberState } from '@/features/shared/hooks';

import {
  stylesAppBar,
  stylesBreadcrumb,
  stylesBreadcrumbParent,
  stylesBreadcrumbCurrent,
  stylesBreadcrumbSeparator,
} from './Header.styles';

export const Header: React.FunctionComponent = () => {
  const { t } = useTranslation('layouts');
  const { featuresFlag } = useFeaturesFlagState();

  const { pathname } = useLocation();
  const { folderNumber } = useFolderNumberState();
  return (
    <AppBar position='sticky' sx={stylesAppBar} color='inherit' elevation={0}>
      {featuresFlag.get(FEATURES_FLAG_KEYS.SHERPASS) && <ConsentBanner />}
      <Toolbar>
        <Box sx={stylesBreadcrumb}>
          {hasToDispalyBreadCrumb(pathname) && (
            <Breadcrumbs
              aria-label='breadcrumb'
              separator={
                <Typography component='span' sx={stylesBreadcrumbSeparator}>
                  /
                </Typography>
              }
            >
              <Typography sx={stylesBreadcrumbParent}>{t('header.breadcrumb.title')}</Typography>
              <Typography color='primary' sx={stylesBreadcrumbCurrent}>
                {folderNumber}
              </Typography>
            </Breadcrumbs>
          )}
        </Box>
        <LanguageSwitcher />
      </Toolbar>
    </AppBar>
  );
};
const hasToDispalyBreadCrumb = (pathname: string) =>
  ![
    '/folders',
    '/subscribe',
    '/pre-folders',
    '/landing-page',
    '/service-offers',
    '/information/cookies-list',
    '/information/security-policy',
    '/information/privacy-statement',
    '/subscribe/additional-information',
  ].includes(pathname) &&
  !pathname.endsWith('/new-request') &&
  !pathname.startsWith('/pre-folders');
